module.exports = __webpack_public_path__ + "img/guidepage-icon.998c2b9e.png";